import {Pipe, PipeTransform} from '@angular/core';
import {Store} from '@ngrx/store';
import * as SharedStoreSelectors from 'app/main/shared/shared/store/shared-store.selector';
import {map, Observable} from 'rxjs';

@Pipe({ name: 'getDocumentType' })

/**
 * returns the image
 */
export class GetDocumentType implements PipeTransform {
    constructor(private _store: Store) { }
    transform(documentTypeId: number): Observable<string> {
        return this._store.select(SharedStoreSelectors.getDocumentTypeById(documentTypeId)).pipe(
            map(result => result?.document_type ?? '')
        );
    }
}
